/* Mandarin locals for flatpickr */
var Flatpickr = Flatpickr || {l10ns: {}};
Flatpickr.l10ns.zh = {};

Flatpickr.l10ns.zh.weekdays = {
	shorthand: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
	longhand: ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"]
};

Flatpickr.l10ns.zh.months = {
	shorthand: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"],
	longhand: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"]
};

Flatpickr.l10ns.zh.rangeSeparator = " 至 ";
Flatpickr.l10ns.zh.weekAbbreviation = "周";
Flatpickr.l10ns.zh.scrollTitle = "滚动切换";
Flatpickr.l10ns.zh.toggleTitle = "点击切换 12/24 小时时制";

if (typeof module !== "undefined") 
	module.exports = Flatpickr.l10ns;




//////////////////
// WEBPACK FOOTER
// ./~/flatpickr/dist/l10n/zh.js
// module id = 189
// module chunks = 0